export default __webpack_public_path__ + "static/media/Run (1).95a8c291.png";